import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, API_URL, resolveMediaUrl } from '../utils/api';

export default function Artists() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const shopId = searchParams.get('shop_id');
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getArtists(shopId ? parseInt(shopId) : null)
      .then(setArtists)
      .catch(err => console.error('Failed to fetch artists:', err))
      .finally(() => setLoading(false));
  }, [shopId]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-base)', color: '#ffffff', padding: '7rem 1.5rem 5rem', fontFamily: "'Roboto', sans-serif" }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: '3rem' }}>
          <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '0.75rem', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '0.5rem' }}>{t('artists.ourProfessionals')}</p>
          <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(2.5rem, 6vw, 4rem)', letterSpacing: '0.06em', color: 'var(--orange)', lineHeight: 1, marginBottom: '0.25rem' }}>{t('artists.artistsTitle')}</h1>
          <div style={{ width: '60px', height: '4px', background: 'var(--orange)', borderRadius: '2px' }} />
        </div>

        {loading ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '1.25rem' }}>
            {[1, 2, 3, 4].map(i => <div key={i} style={{ height: '200px', borderRadius: '10px', background: 'var(--bg-card)', border: '1px solid var(--border)' }} />)}
          </div>
        ) : artists.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '4rem 2rem', border: '1px dashed var(--border-hover)', borderRadius: '12px', background: 'var(--bg-dark)' }}>
            <p style={{ fontSize: '3rem', marginBottom: '1rem' }}>✂️</p>
            <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '1.1rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--orange)' }}>{t('artists.noArtistsFound')}</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '1.25rem' }}>
            {artists.map(artist => (
              <div key={artist.id} className="barber-card" style={{ padding: '1.75rem', textAlign: 'center' }}>
                {/* Avatar */}
                <div style={{ width: '64px', height: '64px', borderRadius: '50%', margin: '0 auto 1rem', overflow: 'hidden', background: 'linear-gradient(135deg, var(--orange), var(--orange-dark))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {artist.photo_url ? (
                    <img src={resolveMediaUrl(artist.photo_url)} alt="" loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '1.6rem', color: '#fff' }}>{artist.name?.[0]?.toUpperCase() || '?'}</span>
                  )}
                </div>
                <h2 style={{ fontFamily: "'Oswald', sans-serif", fontSize: '1.1rem', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--orange)', marginBottom: '0.3rem' }}>{artist.name}</h2>
                <p style={{ fontSize: '0.82rem', color: 'var(--text-muted)', marginBottom: '0.5rem' }}>{artist.role}</p>
                <p style={{ fontSize: '0.9rem', fontWeight: 700, color: 'var(--text-warm)' }}>★ {artist.rating || 'N/A'}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
